<template>
  <div>
    <div class="home text-light flex-column">
      <div class="background bg-1">
        <hooper
          :infinite-scroll="true"
          :auto-play="true"
          :play-speed="6000"
          :transition="300"
          :wheel-control="false"
          :keys-control="false"
          :mouse-drag="false"
          :itemsToSlide="1"
          :itemsToShow="1"
        >
          <slide v-for="(slide, index) in currentSlides" :key="index">
            <div class="slide-img">
              <img class="img" :src="getSlideImage(slide)">
              <div class="text subtitle-2 flex align-center">
                <div>
                  <img class="icon" :src="getSlideIcon(slide)">
                </div>
                <div v-html="formatSlideText(slide)"></div>
              </div>
            </div>
          </slide>
        </hooper>
      </div>
      <header>
<!--        <div class="call-to-action flex-column justify-space-between">-->
<!--          <div class="title subtitle-1">Topázio</div>-->
<!--          <div class="text subtitle-6">-->
<!--            <div class="first">-->
<!--              Fundada em 1996 em Imperatriz - Maranhão, hoje a Topázio possui 25 anos de mercado e um orgulho imenso em-->
<!--              poder ser reconhecida como uma marca que faz a diferença na vida e no dia a dia de tantos brasileiros.-->
<!--            </div>-->
<!--            <div class="second">-->
<!--              A sua produção ultrapassa 50 mil peças por mês, que são comercializadas nos estados do MA, TO, PA, GO, MT,-->
<!--              PI, PB, PE, AM, BA e AP.-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </header>
      <div class="content">
        <div class="section-3 text-tertiary flex-column align-center justify-space-between">
          <span class="title-1">Empresas</span>
          <span class="body-2">As marcas do grupo que compartilham da missão de produzir os melhores móveis para a sua casa</span>
          <!--          <div class="companies flex align-center justify-space-between" v-if="windowWidth > 884">-->
          <!--            <div v-for="(company, index) in companies" :key="index">-->
          <!--              <img :src="require(`@/assets/companies/${company}.png`)">-->
          <!--            </div>-->
          <!--          </div>-->
          <hooper
            v-if="windowWidth > 604"
            :infinite-scroll="true"
            :auto-play="true"
            :play-speed="2000"
            :transition="600"
            :wheel-control="false"
            :keys-control="false"
            :itemsToSlide="1"
            :itemsToShow="windowWidth < 664 ? 4 : 5"
          >
            <slide v-for="(company, index) in companies" :key="index">
              <img :src="getCompanyLogo(company)" @click="linkLogo(company.link)">
            </slide>
          </hooper>
          <hooper
            v-else
            :infinite-scroll="true"
            :auto-play="true"
            :play-speed="2000"
            :transition="600"
            :wheel-control="false"
            :keys-control="false"
            :itemsToSlide="1"
            :itemsToShow="windowWidth > 484 ? 3 : 2"
          >
            <slide v-for="(company, index) in companies" :key="index">
              <img :src="getCompanyLogo(company)" @click="linkLogo(company.link)">
            </slide>
          </hooper>
        </div>
        <div class="section-1 text-tertiary flex-column align-center" :style="scrollY < 340 ? 'opacity: 0' : ''">
          <span class="title-1">Produtos</span>
          <span class="body-2">Conte conosco para encontrar os melhores móveis para o seu lar.</span>
          <div class="products">
            <hooper
              :infinite-scroll="true"
              :auto-play="true"
              :play-speed="6000"
              :transition="600"
              :wheel-control="false"
              :keys-control="false"
            >
              <slide v-for="(slide, index) in products" :key="index" class="carousel flex justify-space-around align-center">
                <div class="flex-column justify-space-between align-center">
                  <div class="title-4" v-if="windowWidth < 950">{{ slide.title }}</div>
                  <div class="background-products gradient">
                    <div>
                      <img :src="getProductImage(slide)">
                    </div>
                  </div>
                  <router-link :to="{ name: `Products`, params: { categoria: slide.img, title: slide.title } }">
                    <button class="btn-outlined" v-if="windowWidth < 950">Ver todos</button>
                  </router-link>
                </div>
                <div class="text-product" v-if="windowWidth > 950">
                  <div class="title-3">{{ slide.title }}</div>
                  <div class="body-4">
                    {{ slide.desciption }}
                  </div>
                  <router-link :to="{ name: `Products`, params: { categoria: slide.img, title: slide.title } }">
                    <button class="btn-outlined">Ver todos</button>
                  </router-link>
                </div>
              </slide>
              <hooper-navigation slot="hooper-addons" v-if="windowWidth < 950"></hooper-navigation>
              <hooper-pagination slot="hooper-addons" v-if="windowWidth > 950"></hooper-pagination>
            </hooper>
          </div>
        </div>
        <div class="call-to-action-banner flex">
          <div class="title-3">
            Encontre um representante
            próximo de você
          </div>
          <button @click="$router.push({ name: 'Representatives' })" class="btn-outlined" style="color: #fafafa; border-color: #FAFAFA">Representantes</button>
        </div>
        <div class="section-2 text-tertiary flex-column align-center justify-space-between" :style="scrollY < 878 ? 'opacity: 0' : ''">
          <span class="title-1">Ambientes</span>
          <span class="body-2">
          Tem sempre um móvel topázio pra completar cada ambiente do seu lar. <br>
          Escolha o seu preferido, navegando pelo ambiente:
        </span>
          <div class="ambientes flex-column align-center justify-space-between">
            <div class="labels flex justify-space-around">
              <button v-for="(ambiente, index) in ambientes" :key="index" class="label" @click="setAmbiente(ambiente)">
                {{ ambiente.label }}
              </button>
            </div>
            <div class="ambiente-content flex align-center justify-space-between" v-if="ambiente">
              <div class="text-ambiente">
                <div>
                  <div class="title-3">{{ ambiente.label }}</div>
                  <div class="body-4">
                    {{ ambiente.description }}
                  </div>
                </div>
                <router-link :to="ambiente.route">
                  <button class="btn-outlined">Ver todos</button>
                </router-link>
              </div>
              <div class="flex">
                <div v-for="(img, index) in ambientes" :key="index" class="ambiente-img gradient">
                  <div>
                    <img v-show="img.value == ambiente.value" :src="getAmbienteImage(img)" width="500">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation, Pagination as HooperPagination } from 'hooper'
import 'hooper/dist/hooper.css'
import api from '@/services/api'

export default {
  name: 'Home',
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      scrollY: window.scrollY,
      loading: true,
      windowWidth: window.innerWidth,
      // Dados da API (sem fallbacks - vazio se API não retornar)
      slides: [],
      apiCompanies: [],
      apiProducts: [],
      apiAmbientes: [],
      ambiente: null
    }
  },
  computed: {
    // Usa dados da API (vazio se não retornar)
    products () {
      return this.apiProducts.map(cat => ({
        img: cat.slug,
        title: cat.name,
        desciption: cat.description || '',
        imageUrl: cat.imageUrl || ''
      }))
    },
    companies () {
      return this.apiCompanies.map(comp => ({
        company: comp.name?.toLowerCase().replace(/\s+/g, '-') || comp.slug,
        link: comp.websiteUrl || '/',
        logoUrl: comp.logoUrl
      }))
    },
    ambientes () {
      return this.apiAmbientes.map(env => ({
        label: env.name,
        value: env.slug,
        route: env.categorySlug ? `produtos/${env.categorySlug}` : 'produtos',
        description: env.description || '',
        imageUrl: env.imageUrl
      }))
    },
    currentSlides () {
      return this.slides
    }
  },
  async created () {
    await this.fetchHomeData()
    // Define ambiente inicial (se houver)
    if (this.ambientes.length > 0) {
      this.ambiente = this.ambientes[this.ambientes.length - 1]
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  },
  methods: {
    async fetchHomeData () {
      try {
        const data = await api.getHome()
        if (data.slides) this.slides = data.slides
        if (data.companies) this.apiCompanies = data.companies
        if (data.categories) this.apiProducts = data.categories
        if (data.environments) this.apiAmbientes = data.environments
      } catch (error) {
        console.error('Erro ao carregar dados da home:', error)
      } finally {
        this.loading = false
      }
    },
    setAmbiente (value) {
      this.ambiente = value
    },
    linkLogo (link) {
      window.open(link, '_blank')
    },
    // Helper para imagens - usa URL da API (vazio se não tiver)
    getSlideImage (slide) {
      return slide.imageUrl || ''
    },
    getSlideIcon (slide) {
      return slide.iconUrl || ''
    },
    getCompanyLogo (company) {
      return company.logoUrl || ''
    },
    getAmbienteImage (ambiente) {
      return ambiente.imageUrl || ''
    },
    formatSlideText (slide) {
      if (slide.title && slide.subtitle) {
        return `<b>${slide.title}</b><br>${slide.subtitle}`
      }
      return slide.text || ''
    },
    getProductImage (product) {
      return product.imageUrl || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  justify-content: start;
  position: relative;
  overflow: hidden;
}
#content {
  margin: 0 !important;
}
.home header{
  width: 100%;
  max-width: 1375px;
  margin: auto;
  z-index: 1;
}
.home .background .hooper {
  transform: rotate(3.5deg);
  position: absolute;
  width: 100%;
  top: 10px;
  left: -3px;
  height: 105%;
  .text {
    position: absolute;
    bottom: 70px;
    left: 20vw;
    min-width: 220px;
    max-width: 400px;
    text-align: left;
    margin: 25px;
    font-size: 26px;
    line-height: 25px;
    b {
      font-size: 30px;
    }
    .icon {
      height: 60px;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }
  .slide-img {
    position: relative;
    margin: auto;
    overflow: hidden;
    height: 100%;
    .img {
      min-width: 1152px;
      width: 85%;
      transition: all .4s ease;
    }
  }
  .slide-img:hover > .img {
    //transform: scale(1.05);
    width: 89%;
  }
}
.home .content {
  padding: 0 0;
  width: 100%;
  max-width: 1875px;
  margin: 380px auto 150px auto;
}
@media screen and (max-width: 678px) {
  .home header {
    padding: 40px 5px;
    justify-content: center;
  }
  .home .content {
    padding: 0 0;
  }
}
//.call-to-action {
//  text-align: left;
//  min-height: 170px;
//  .text {
//    max-width: 630px;
//    margin-bottom: 4px;
//    .first {
//      margin: 20px 0;
//    }
//  }
//}
//@media screen and (max-width: 1086px) {
//  .call-to-action {
//    max-width: 49vw;
//    min-height: 200px;
//  }
//}
@media screen and (max-width: 738px) {
  .home .background .hooper {
    .slide-img {
      .img {
       margin-left: -150px;
      }
      .text {
        bottom: 120px;
        left: 100px;
        font-size: 24px;
        flex-direction: column;
        align-items: start;
        max-width: 270px;
        b {
          font-size: 28px;
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .home .background .hooper {
    .slide-img {
      .img {
        margin-left: -430px;
        min-width: 1120px;
      }
      .text {
        left: 60px
      }
    }
  }
}
@media screen and (max-width: 801px) {
  //header .hooper {
  //  padding: 0 !important;
  //  height: 340px;
  //  max-height: 340px;
  //  width: 250vw;
  //  max-width: 1177px;
  //  margin-top: 70px;
  //  .text {
  //    width: 100%;
  //    max-width: 432px;
  //    flex-direction: column !important;
  //  }
  //  .slide-img {
  //    margin: auto;
  //    overflow: hidden;
  //    height: 100%;
  //    max-height: 578px;
  //    max-width: 1200px;
  //    img {
  //      margin-left: -50%;
  //    }
  //  }
  //}
  .subtitle-6 {
    font-size: 16px !important;
  }
  //.call-to-action {
  //  margin-top: -30px;
  //}
}
@media screen and (max-width: 788px) {
  //.call-to-action {
  //  max-width: 70vw;
  //  min-height: 200px;
  //}
  .subtitle-6 {
    font-size: 14px !important;
    line-height: 20px;
  }
}
@media screen and (max-width: 898px) {
  header {
    flex-direction: column-reverse;
    padding: 0 !important;
  }
  //.call-to-action {
  //  margin-top: 130px;
  //  max-width: 75vw;
  //  min-height: 200px;
  //  text-align: center;
  //  align-items: center;
  //}
}
//@media screen and (max-width: 388px) {
//  .text .first {
//    margin: 5px 0 !important;
//  }
//}
.home .background {
  position: absolute;
  overflow: hidden;
  top: -170px;
  left: -15vw;
  z-index: 0;
  width: 130vw;
  min-height: 630px;
  max-height: 700px;
  border-radius: 17%;
  transform: rotate(-3.5deg);
  background: #005245;
  background-size: cover;
  box-shadow: 0px 3px 5px rgba(80, 80, 80, 0.52);
}

.call-to-action-banner {
  margin: 40px 0;
  width: 100%;
  justify-content: center;
  padding: 50px 0px;
  background: rgba(0, 82, 69, 0.76);
  align-items: center;
  gap: 20%;
  flex-wrap: wrap;
  text-align: left;
  .title-3 {
    max-width: 370px;
  }
  .btn-outlined {
    max-height: 30px;
    min-width: 180px;
  }
}
@media screen and (max-width: 684px){
  .call-to-action-banner {
    text-align: center;
    .btn-outlined {
      margin-top: 20px;
    }
  }
}

.background-products {
  min-width: 250px;
  min-height: 200px;
  width: 32vw;
  height: 23vw;
  max-width: 373px;
  max-height: 268px;
  margin: 20px 0;
  overflow: hidden;
  border-radius: 20px;
}
.background-products div {
  width: 100%;
  height: 100%;
  background: url("../assets/logos/logo-icon.png") no-repeat center;
  background-size: 10vw;
}

//@media screen and (max-width: 800px){
//  .home .background {
//    min-height: 480px;
//    max-height: 500px;
//  }
//}
//@media screen and (max-width: 425px){
//  .home .background {
//    min-height: 480px;
//    max-height: 500px;
//  }
//}

// products
.section-1 {
  transition: all 1s ease;
}
.section-1 .products{
  width: 100%;
}
@media screen and (min-width: 485px){
  .section-1 {
    padding: 0 100px;
  }
}
.products .hooper {
  min-height: 380px;
  img {
    height: 110%;
    margin-top: -0px;
    margin-left: -0px;
  }
}

.products .carousel {
  padding: 0 0px;
  .body-4 {
    max-width: 440px;
    margin: 20px 0;
  }
}

// ambientes
.section-2 {
  transition: all 1s ease;
  min-height: 390px;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  .body-2 {
    max-width: 600px;
  }
  .ambientes {
    width: 100%;
    .ambiente-content {
      gap: 20px !important;
    }
    .ambiente-img {
      margin-top: 20px;
      min-height: 180px;
      max-height: 180px;
      max-width: 400px;
      div {
        width: 100%;
        min-height: 200px;
        background: url("../assets/logos/logo-icon.png") no-repeat center;
        background-size: 100px;
      }
    }
    .ambientes-buttons {
      min-width: 100%;
    }
    .body-4 {
      max-width: 450px;
      margin: 20px 0;
    }
    img {
      min-width: 370px;
      width: 100%;
      max-width: 600px;
      border-radius: 15px;
      box-shadow: 0px 3px 3px rgba(80, 80, 80, 0.32);
    }
    @media screen and (max-width: 898px) {
      .ambientes-buttons {
        justify-content: space-around;
        min-width: 100%;
        transform: scale(0.7);
      }
    }
    @media screen and (max-width: 425px) {
      .ambientes-buttons {
        transform: scale(0.55);
      }
      .ambiente-content .body-4 {
        max-width: 300px;
      }
    }
    @media screen and (max-width: 950px) {
      .ambiente-content {
        flex-direction: column-reverse;
        .ambiente-img {
          margin-bottom: 40px;
        }
        .btn-outlined {
          margin-top: 10px;
        }
      }
    }
  }
}

// companies
@media screen and (max-width: 792px){
  .section-3 {
    margin-top: -80px;
  }
}
.section-3 {
  background: #E1E1E1;
  padding: 140px 0 60px 0;
  height: 250px;
  overflow: visible;
  margin-top: -20px;
  margin-bottom: 80px;
  div {
    width: 90%;
    overflow: visible;
    margin-bottom: 10px;
  }
  img {
    // filter: saturate(0);
    // opacity: .7;
    margin-top: 30px;
    overflow: visible;
    max-width: 150px;
    max-height: 80px;
    width: 90px;
    min-width: 50px;
    transform: scale(1.5);
    cursor: pointer;
    transition: all .2s ease;
  }
  //img:hover {
  //  filter: saturate(1);
  //  opacity: .9;
  //}
}
@media screen and (min-width: 1103px){
  .section-3 {
    margin-top: -15px;
  }
}
.body-2 {
  margin: 10px 0 20px 0;
  width: 80%;
  max-width: 420px;
}
.home .content .btn-outlined {
  border-color: #00B445;
  color: #00B445;
}
.home .content .btn-outlined:hover {
  border-color: #505050;
  color: #FAFAFA;
}
.content .labels {
  justify-content: center;
  width: 100%;
  display: flex;
  gap: 20px;
  margin: 25px 0;
  flex-wrap: wrap;
  .label {
    cursor: pointer;
    user-select: none;
    width: 100px;
    height: 24px;
    padding: 1px 10px;
    font-size: 12px;
    border: solid 1px #005245;
    border-radius: 6px;
    transition: all .3s ease;
    text-decoration: none;
    color: #005245;
  }
  .label:hover {
    background-color: #005245;
    color: #FAFAFA;
  }
}
</style>